import { MouseEventHandler } from 'react'
import classNames from 'classnames'
import styles from './Actions.module.css'

interface DeleteButtonProps {
  onClick: MouseEventHandler<HTMLDivElement>
  isSmallSize?: boolean
}

const DeleteButton = ({ onClick, isSmallSize }: DeleteButtonProps) => (
  <div
    onClick={onClick}
    className={classNames(
      styles.btn,
      styles.btnSmall,
      styles.btnIcon,
      styles.btnOutline,
      { [styles.isSmallSize]: isSmallSize }
    )}
  >
    <i className={classNames(styles.icon, styles.iconDeleteRed)} />
  </div>
)

export default DeleteButton
